import { render, staticRenderFns } from "./TaskKanbanItem.vue?vue&type=template&id=f2c98432&scoped=true&"
import script from "./TaskKanbanItem.vue?vue&type=script&lang=js&"
export * from "./TaskKanbanItem.vue?vue&type=script&lang=js&"
import style0 from "~/components/orderKanban/OrderKanbanItem.scss?vue&type=style&index=0&id=f2c98432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c98432",
  null
  
)

export default component.exports